module.exports = __webpack_public_path__ + "media/fr_ca_s4_Thierry.959ad2f0.oga";